import React from "react";
import * as Mui from "@mui/material";
import { Construction } from "@mui/icons-material";
import {
  designColors,
  designFontFamily,
  designRadii,
} from "services/constants/designTokens";

// Placeholder for Payroll screens that are in the new menu but not built
// yet (Statutory, Statutory Reports, ...). Pass the screen's title.
export const NotImplemented = ({ title }) => (
  <Mui.Box
    sx={{
      minHeight: "calc(100vh - 120px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      px: 2,
      fontFamily: designFontFamily,
    }}
  >
    <Mui.Box
      sx={{
        maxWidth: 440,
        width: "100%",
        textAlign: "center",
        p: 4,
        border: `1px solid ${designColors.slate200}`,
        borderRadius: designRadii.card,
        backgroundColor: designColors.white,
      }}
    >
      <Mui.Box
        sx={{
          width: 56,
          height: 56,
          mx: "auto",
          mb: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: designRadii.pill,
          backgroundColor: designColors.tealTint,
          color: designColors.teal,
        }}
      >
        <Construction />
      </Mui.Box>
      <Mui.Typography
        sx={{
          fontFamily: designFontFamily,
          fontSize: 18,
          fontWeight: 600,
          color: designColors.slate900,
          mb: 1,
        }}
      >
        {title}
      </Mui.Typography>
      <Mui.Typography
        sx={{
          fontFamily: designFontFamily,
          fontSize: 14,
          color: designColors.slate600,
        }}
      >
        This feature is not implemented yet. It will be available in a future
        update.
      </Mui.Typography>
    </Mui.Box>
  </Mui.Box>
);
